import React from 'react';
import PropTypes from 'prop-types';

import Label from '../Label';

import * as S from './styles';

const CreatableField = ({
  placeholderText,
  handleChange,
  handleInputChange,
  options,
  labelText,
  inputName,
  isClearable,
  value,
  isDisabled,
}) => (
  <>
    <Label htmlFor={inputName} text={labelText} />
    <S.CreatableSelect
      isClearable={isClearable}
      noOptionsMessage={() => 'Opção não encontrada'}
      name={inputName}
      id={inputName}
      placeholder={placeholderText}
      onChange={handleChange}
      onInputChange={handleInputChange}
      options={options}
      value={value}
      isDisabled={isDisabled}
    />
  </>
);

export default CreatableField;

CreatableField.defaultProps = {
  placeholderText: 'Selecione...',
  value: {
    label: '',
    value: '',
  },
  isDisabled: false,
};

CreatableField.propTypes = {
  placeholderText: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  value: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
  labelText: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  isClearable: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
};
